import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-trading-partner-modal',
  templateUrl: './trading-partner-modal.component.html',
  styleUrls: ['./trading-partner-modal.component.scss'],
})
export class TradingPartnerModalComponent implements OnInit {
  public formTradingPartnerModal: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<TradingPartnerModalComponent>,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.formTradingPartnerModal = this.formBuilder.group({
      typeGroup: ['Customer', Validators.required],
    });
  }

  onSubmit() {
    const selectedType = this.formTradingPartnerModal.value.typeGroup;
    this.closeDialog(selectedType);
  }

  closeDialog(values: any = null) {
    this.dialogRef.close(values);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/trading-partners/trading-partner-modal/trading-partner-modal.component.ts